import { render, staticRenderFns } from "./textAnnotation.vue?vue&type=template&id=e356cd94&"
import script from "./textAnnotation.vue?vue&type=script&lang=js&"
export * from "./textAnnotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports